import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectCartItems, addToCart, removeFromCart, updateItemQuantity } from '../store/cartSlice';
import { assets } from '../assets/assets';

const Cart = () => {
    const dispatch = useDispatch();

    const cartData = useSelector(selectCartItems);

    const currency = useSelector(state => state.shop.currency);

    const totalPrice = cartData.reduce((total, item) => total + item.price * item.quantity, 0);

    const incrementQuantity = (item) => {
        const incrementStep = item.minQuantity || 1;

        dispatch(updateItemQuantity({
            id: item.id,
            quantity: item.quantity + incrementStep,
        }));
    };

    const decrementQuantity = (item) => {
        const step = item.minQuantity || 1;
        const newQuantity = item.quantity - step;
        console.log(newQuantity, step);
        
        if (newQuantity >= step) {
            dispatch(updateItemQuantity({
                id: item.id,
                quantity: newQuantity,
            }));
        } else {
            // If you want to remove the item when below minQuantity:
            dispatch(removeFromCart({ id: item.id }));
            
            // Or if you want to set it back to minQuantity:
            // dispatch(updateItemQuantity({
            //     id: item.id,
            //     quantity: step,
            // }));
        }
    };

    const handleRemove = (item) => {
        dispatch(removeFromCart({ id: item.id }));
    };
    
    return (
        <div className="cart_section">
            <div className="cart_heading mb-5">
                <div className="container">
                    <div className="row">
                        <div className="add-to d-flex align-items-center justify-content-between">
                            <h4>Your Cart</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="mb-5">
                    {cartData.length > 0 ? (
                        cartData.map((item, index) => (
                            <div key={item.id} className="cart_item overflow-hidden">
                                <h4 className="cart-title mb-3">{item.name}</h4>
                                <div className="d-md-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center mb-5 mb-sm-0">
                                        <div className="product_img me-3">
                                            <img src={item.thumbnail_imge || assets.logo} className="img-fluid" alt={item.name} />
                                        </div>
                                        <div className="link_txt">
                                            <strong className="unit">{currency}{item.price}/Unit</strong>
                                            <p className="name">{item.name}</p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="quantity me-0 me-sm-5">
                                            <button className="minus-btn" onClick={() => decrementQuantity(item)}>-</button>
                                            <input type="text" className="border-0 bg-transparent" readOnly value={item.quantity} />
                                            <button className="plus-btn" onClick={() => incrementQuantity(item)}>+</button>
                                        </div>
                                        <div className="icon">
                                            <button
                                                type="button"
                                                className="bg-transparent border-0"
                                                onClick={() => handleRemove(item)}
                                            >
                                                <img className="img-fluid close-btn" src={assets.close_icon} alt="Remove" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>Your cart is empty.</p>
                    )}
                </div>
            </div>

            <div className="total_pay">
                <div className="container">
                    <div className="add-to d-flex align-items-center justify-content-between mt-4">
                        <div className="cart-balance">
                            <strong>{currency}{totalPrice}</strong>
                            <p>Total Pay Amount</p>
                        </div>
                        <Link to="/checkout" className="btn btn-primary shadow-none rounded-2 py-2">Checkout</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cart;
